module.exports = __webpack_public_path__ + "static/img/5.03e0395.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/eng/5.png
// module id = iqxw
// module chunks = 0